import React, { useState, useEffect } from 'react';
import '../styles/AddTaskForm.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan, faPlus } from "@fortawesome/free-solid-svg-icons";
import { API_BASE_URL } from '../config';

function AddTaskForm({ employeeId, closeModal, showDateInput = true, selectedDate = '', onTaskAdded, onSubTaskAdded }) {
    const [taskName, setTaskName] = useState('');
    const [description, setDescription] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [dueTime, setDueTime] = useState('');
    const [priority, setPriority] = useState(false);
    const [subTaskName, setSubTaskName] = useState('');
    const [subTasks, setSubTasks] = useState([]);
    const [subTaskNeedPhoto, setSubTaskNeedPhoto] = useState(false);

    useEffect(() => {
        if (selectedDate) {
            const formattedDate = formatDate(selectedDate);
            setDueDate(formattedDate);
        }
    }, [selectedDate]);

    const formatDate = (date) => {
        const year = date.getFullYear();
        let month = (1 + date.getMonth()).toString().padStart(2, '0');
        let day = date.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    const addSubTask = () => {
        if (subTaskName.trim() !== '') {
            setSubTasks([...subTasks, { description: subTaskName, needPhoto: subTaskNeedPhoto } ]);
            setSubTaskName('');
            setSubTaskNeedPhoto(false);
        }
    };

    const removeSubTask = (index) => {
        const updatedSubTasks = [...subTasks];
        updatedSubTasks.splice(index, 1);
        setSubTasks(updatedSubTasks);
    };

    const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        const taskData = {
            taskName: taskName,
            description: description,
            dueDate: dueDate,
            dueTime: dueTime,
            child: {
                id: employeeId,
            },
            priority: priority,
        };
        let savedUser = JSON.parse(localStorage.getItem('user'));
        const response = await fetch(`${API_BASE_URL}/api/v1/task`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization":`Bearer ${savedUser["jwtToken"]}`
            },
            body: JSON.stringify(taskData),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const responseData = await response.json();
        const taskId = responseData.id;

        if (subTasks.length > 0) {
            await Promise.all(subTasks.map(async (subTask) => {
                const subTaskData = {
                    description: subTask.description,
                    needPhoto: subTask.needPhoto,
                    task: {
                        id: taskId,
                    },
                };
                let savedUser = JSON.parse(localStorage.getItem('user'));

                const subTaskResponse = await fetch(`${API_BASE_URL}/api/v1/task/sub`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization":`Bearer ${savedUser["jwtToken"]}`
                    },
                    body: JSON.stringify(subTaskData),
                });

                if (!subTaskResponse.ok) {
                    throw new Error('Network response was not ok');
                }
            }));
        }

        setTaskName('');
        setDescription('');
        setDueDate('');
        setDueTime('');
        setPriority(false);
        setSubTasks([]);

        closeModal();
        onTaskAdded(responseData);
    } catch (error) {
        console.error(error);
    }
};


    return (
        <form className="addTask-form" onSubmit={handleSubmit}>
            <div className='div-form'>
                <label>Naziv zadatka:</label>
                <input type="text" value={taskName} onChange={(e) => setTaskName(e.target.value)} required />
            </div>
            <div className='div-form'>
                <label>Opis:</label>
                <input type="text" value={description} onChange={(e) => setDescription(e.target.value)} required />
            </div>
            {showDateInput && (
            <div className='div-form'>
                <label>Rok:</label>
                    <input type="date" value={dueDate} onChange={(e) => setDueDate(e.target.value)} required />
                    <input type="time" value={dueTime} onChange={(e) => setDueTime(e.target.value)} required />
                </div>
            )}
            {!showDateInput && (
                <div className='div-form'>
                    <label>Rok:</label>
                    <input type="date" value={selectedDate ? formatDate(selectedDate) : ''} readOnly />
                    <input type="time" value={dueTime} onChange={(e) => setDueTime(e.target.value)} required />
                </div>
            )}
            <div className='div-form'>
                <label>Prioritet:</label>
                <input
                    type="checkbox"
                    checked={priority}
                    onChange={(e) => setPriority(e.target.checked)}
                />
            </div>
            <h4>Podzadaci:</h4>
            <div className="sub-tasks-container">
                {subTasks.map((subTask, index) => (
                    <div key={index} className="sub-task-item">
                        <p>{subTask.description} {subTask.needPhoto && "(Potrebna slika)"}</p>
                        <button className="delete-subtask-button" onClick={() => removeSubTask(index)}>
                            <FontAwesomeIcon icon={faTrashCan} style={{ color: "#C70000" }} />
                        </button>
                    </div>
                ))}
            </div>
            <div className="add-subtask-form">
                <div className='div-form'>
                    <label>Naziv:</label>
                    <input type="text" name="subTaskName"  value={subTaskName} onChange={(e) => setSubTaskName(e.target.value)} />
                </div>
                <div className='div-form-toggle'>
                    <label>Potrebna slika:</label>
                    <label className="toggle">
                        <input type="checkbox" checked={subTaskNeedPhoto} onChange={(e) => setSubTaskNeedPhoto(e.target.checked)} />
                        <span className="slider"></span>
                    </label>
                    <button className='add-subtask' type="button" onClick={addSubTask}>
                        <FontAwesomeIcon icon={faPlus} style={{ color: "#2a68db", border: "none" }} size="2x" />
                    </button>
                </div>

            </div>
            <button type="submit">Dodaj zadatak</button>
        </form>
    );
}

export default AddTaskForm;
